import { Box, Typography } from "@mui/material"

const SectionHeader = ({ children, sectionTitle }) =>
  <Box
    display='flex'
    alignItems='center'
    width='80vw'
    sx={{ mt: 5 }} >
    {children}
    <Typography
      variant='title_bold'
      sx={{ p: 1, fontSize: "1rem" }}
    >
      {sectionTitle}
    </Typography>
  </Box>

export default SectionHeader